export class TokenAcquisitionError extends Error {
  constructor(message: string = 'Token acquisition failed') {
    super(message);
    this.name = 'TokenAcquisitionError';
    Object.setPrototypeOf(this, TokenAcquisitionError.prototype);
  }
}
